import { render } from "./localidades.vue?vue&type=template&id=635afc30&scoped=true"
import script from "./localidades.vue?vue&type=script&lang=js"
export * from "./localidades.vue?vue&type=script&lang=js"

import "./localidades.vue?vue&type=style&index=0&id=635afc30&scoped=true&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635afc30"]])

export default __exports__